






























































import Component from 'vue-class-component';
import Vue from 'vue';
import * as ent from '@/entities';
import { MasterPageCriteria } from '@/components/base/master/master-page-criteria';
import adminsApi from '@/api/admins.api';
import store from '@/store/store';
import * as types from '@/store/types';

@Component({})
export default class AdminsMaster extends MasterPageCriteria {
    public items: ent.IAdminAccountModel[] = [];

    protected defaultSort: ent.ISort = {
        field: 'username',
        asc: true
    };

    public created() {
        this.search();
    }

    public async list(
        body: ent.ISearchBody
    ): Promise<ent.IPaging<ent.IAdminAccountModel>> {
        const admins = await adminsApi.list();
        return ent.withPaging(admins);
    }

    //   public remove(item: ent.ISiteManualListModel) {
    //     let afterFn = async (closeFn: () => void) => {
    //       try {
    //         await siteManualsApi.delete(item.id);
    //         // reload
    //         await this.search();
    //       } finally {
    //         closeFn();
    //       }
    //     };
    //     let payload: ent.IConfirm = {
    //       heading: `Are your sure to remove "${item.sitename}" manual?`,
    //       afterFn
    //     };

    //     store.dispatch(types.SHOW_CONFIRM, payload);
    //   }
}
